import React from 'react';
import KPILoader from 'components/utility/ContentLoader/KPILoader/RedesignedKPILoader';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const KPIListLoader: React.FC<{
  isMobileView: boolean;
  arrayCount: number;
  width?: number;
}> = (props) => {
  const { isMobileView, arrayCount, width } = props;

  return (
    <>
      {isMobileView ? (
        <ContentLoader width={200} height={125}>
          <rect width="200" height="20" x="0" y="0" />
          <rect width="200" height="20" x="0" y="25" />
          <rect width="200" height="20" x="0" y="50" />
          <rect width="200" height="20" x="0" y="75" />
          <rect width="200" height="20" x="0" y="100" />
        </ContentLoader>
      ) : (
        Array(arrayCount)
          .fill(0)
          .map((value, index) => (
            <KPILoader key={index + 'key'} small={index !== 0} width={width} />
          ))
      )}
    </>
  );
};

export default KPIListLoader;
